module.exports = __webpack_public_path__ + "static/media/mindset.e38b6cf3.png";